import { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setMounted(true), []);

  if (!mounted) return <div className="p-2 w-10 h-10" />;

  return (
    <button
      onClick={toggleTheme}
      className="p-2.5 rounded-xl transition-all duration-300 hover:scale-110 active:scale-95 flex items-center justify-center group"
      style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)' }}
      aria-label="Changer le thème"
    >
      {theme === 'dark' ? (
        <Sun size={18} className="text-yellow-400 group-hover:rotate-45 transition-transform" />
      ) : (
        <Moon size={18} className="text-blue-600 group-hover:-rotate-12 transition-transform" />
      )}
    </button>
  );
};

export default ThemeToggle;
